export default __webpack_public_path__ + "static/media/loading.8c00e1e0.svg";